module.exports = __webpack_public_path__ + "img/left_bg.02f4e61.png";